import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './payment-gateway-modal.css';
import monday from './pictures/momo.png';
import money from './pictures/Money.png';
import Ben from './pictures/ben.png';
import koko from './pictures/koko.png';
import api from '../../../../service/caller.js'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { FaArrowLeft } from "react-icons/fa";


const PaymentGatewayModal = ({ onClose, billing, amountToPay }) => {
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [UserData, setUserData] = useState([]);
  const [phone, setPhoneNumber] = useState('');
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [paymentdetails, setPaymentdetails] = useState('');
  const [cashOption, setCashOption] = useState('total'); // 'total' ou 'partial'
  const [cashAmount, setCashAmount] = useState('');
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();
  const now = new Date();

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };

    fetchLoggedUserData();
  }, []);

  const handlePaymentMethodSelect = (method) => {
    setPaymentMethod(method);
  };

  const handleConfirmPayment = () => {
    if ((paymentMethod === 'mobile-money' && phone) || paymentMethod === 'card') {
      setPaymentStatus('success');
    }
  };


  // Paybymomo
  const handleMomoPaymentConfirmation = async () => {
    const billingID = billing._id;

    // Vérifier si paymentMethod est sélectionné et si le téléphone est renseigné pour 'mobile-money'
    if (!paymentMethod) {
      toast.error('Please select a payment method.');
      return;
    }

    if (paymentMethod === 'mobile-money' && !phone) {
      toast.error('Please enter your phone number.');
      return;
    }

    if (paymentMethod === 'cash') {
      const amountentered = parseFloat(cashAmount);
      if (!amountentered || amountentered <= 0) {
        toast.error("Veuillez entrer un montant valide.");
        return;
      }

      if (cashOption === 'total' && amountentered !== amountToPay) {
        toast.error(`Montant incorrect. Vous devez payer exactement ${amountToPay} ${billing.hospitalId.hospital_currency} .`);
        return;
      }

      // if (cashOption === 'partial' && amountentered >= billing.amount) {
      //   toast.error(`Montant trop élevé pour un paiement partiel.`);
      //   return;
      // }

      try {
        const currency = billing.hospitalId.hospital_currency;
        const paymentstatus = true;
        const paymentMethod = 'cash';
        const caissiereId = UserData._id;
        const calculaterestamount = (amountToPay) - amountentered;

        const paymentInfo = await api.put(`clinic/billing/updatepaystatus/${billingID}`, {
          paymentstatus,
          paymentMethod,
          currency,
          montantpaye: amountentered,
          montantrestant: calculaterestamount,
          caissiereId,
        });

        setPaymentStatus('success');
        setPaymentdetails(paymentInfo.data.billing);
      } catch (error) {
        toast.error('Erreur lors de l’enregistrement du paiement.');
        console.error(error);
      }

      return;
    }

    // Préparation des données de paiement
    const caissiereId = UserData._id ;

    const paymentData = {
      item_name: 'Billing Payment',
      amount: amountToPay,
      currency: billing.hospitalId.hospital_currency,
      phoneNumber: phone,
      payerMessage: billing.purpose,
      paymentReason: 'Payment for this billing',
      motifId: billingID,
      caissiereId,
    };

    try {
      const paymentResponse = await api.post(`/payment/paymentmomo/initiate`, paymentData);

      if (paymentResponse?.status === 200) {
        // setPaymentdetails(paymentResponse.data.payment);
        const paymentstatus = true;
        const currency = paymentData.currency;
        const montantrestant = 0;
        const montantpaye = amountToPay;
        setPaymentStatus('success');
        const paymentInfo = await api.put(`clinic/billing/updatepaystatus/${billingID}`, { paymentstatus: paymentstatus, paymentMethod, currency, montantrestant, montantpaye, caissiereId });

        setPaymentdetails(paymentInfo.data.billing);

      } else {
        toast.error("Payment failed!");
      }
    } catch (error) {
      console.error('Erreur lors du paiement:', error);
      toast.error(`Payment failed: ${error?.message}. Please try again.`);
    }
  };


  // Generate PDF from receipt element
  const generatePdf = async () => {
    const element = document.querySelector('.recu');
    if (!element) return null;

    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff'
      });

      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210; // A4 width
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);

      // Return the PDF as blob
      return pdf.output('blob');
    } catch (error) {
      console.error('Erreur de génération PDF:', error);
      return null;
    }
  };

  const handleValidate = async () => {
    setSending(true);

    try {
      // Generate PDF file
      const pdfBlob = await generatePdf();

      if (!pdfBlob) {
        toast.error("Impossible de générer le PDF");
        setSending(false);
        return;
      }

      // Create FormData to send the file
      const formData = new FormData();
      formData.append('pdfReceipt', pdfBlob, `${billing.paymentuniqueId}_recupayement.pdf`);
      formData.append('patientId', billing.patientId);
      formData.append('subject', 'Votre reçu de paiement');
      formData.append('receiptId', billing.paymentuniqueId);
      formData.append('amount', billing.amount);

      // Send email with PDF attachment
      const response = await api.post('/api/send-receipt-email', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        toast.success('Le reçu a été envoyé avec succès au patient');
        // Redirect after successful email sending
        setTimeout(() => {
          navigate('/Billings/allpaymentlist');
        }, 2000);
      } else {
        toast.error("Échec de l'envoi de l'email");
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi de l\'email:', error);
      toast.error(`Échec de l'envoi: ${error?.message}`);
    } finally {
      setSending(false);
    }
  };

  const handleDownload = async () => {
    const element = document.querySelector('.recu');
    if (!element) return;

    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff'
      });

      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      const imgWidth = 210; // A4 width
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
      pdf.save(`${billing.paymentuniqueId}_recupayement.pdf`);
      setTimeout(() => {
        navigate('/Billings/allpaymentlist');
      }, 2000);
    } catch (error) {
      console.error('Erreur de génération PDF:', error);
    }
  };


  if (paymentStatus === 'success') {
    return (
      <>
        <div className="payment-gateway-success-modal">
          <div className="payment-gateway-success-content">
            <div className='range'>
              <button
                className="sucess-gateway-modal-close"
                onClick={onClose}
              >
                ← Retour
              </button>
            </div>
            <div>
              <h2 className='sagbo'>Successful payment</h2>
              <p>Votre paiement a été effectué avec succès.</p>
              <img src={Ben} alt="Ben" className="Ben" />
            </div>
            <div>
              <button onClick={() => setShowTicketModal(true)} className='woro'> Voir la Facture</button>
            </div>
          </div>
        </div>

        {showTicketModal && (
          <div className="ticket-modal-overlay">
            <div className="ticket-modal-content">
              <div className="modal-container">
                <div className="modal-header3">
                  <h3>Recu Medical</h3>
                </div>
                <button className="btn btn mb-4 toute" onClick={() => navigate(-1)}>
                  <FaArrowLeft /> Retour
                </button>
                <div className="recu">
                  <div className="receipt-header">
                    <div className="logoi">
                      <img src={UserData?.hospital_id[0]?.picture || koko} alt="koko" className="koko" />
                    </div>
                    <div className="title">
                      <p>RECU DE <br></br> PAIEMENT</p>
                    </div>
                  </div>
                  <div className="receipt-id">
                    <span>Receipt ID</span>
                    <div>{billing.paymentuniqueId}</div>
                  </div>

                  <div className="receipt-datetime">
                    <div className="date">
                      <p><strong>Date: </strong>{now.toDateString()}</p>
                      <p><strong>Time: </strong>{now.toLocaleTimeString()}</p>
                    </div>
                    <div className="timeler">
                      <p><strong>Name:</strong>{billing.patientId.lastname} {billing.patientId.firstname}</p>
                    </div>
                  </div>
                  <div className='ici'>
                    <p className='vies'>Services</p>
                    <p className='vies'>Prix</p>
                  </div>
                  <div className="service-item">
                    <span>Consultation</span>
                    <span>{billing.amount} XOF</span>
                  </div>
                  <div className="receipt-content">
                    <div className="total">
                      <span>Total</span>
                      <span>{billing.amount} X0F</span>
                    </div>
                  </div>
                  <div className='gagn'>
                    <p>Montant Payé </p>
                    <p>{paymentdetails.montantpaye}</p>
                  </div>
                  <div className='gagn'>
                    <p>Montant Restant </p>
                    <p>{paymentdetails.montantrestant}</p>
                  </div>

                  <div className="payment-info">
                    <div>Payment by: <strong>{paymentdetails?.paymentMethod}</strong></div>
                    <div className="reference">Reference No: {phone}</div>
                    <div>Statut: Payed</div>
                  </div>

                  <div className="receipt-footer">
                    <p>
                      Le reçu fait office de justificatif <br></br>
                      de paiement. Veuillez le conserver.
                    </p>
                    <p className='atroce'>SIGNATURE</p>
                  </div>
                </div>
                <div className='separate'>
                  <button
                    className='auto'
                    onClick={handleValidate}
                    disabled={sending}
                  >
                    {sending ? 'Envoi en cours...' : 'Envoyer au patient'}
                  </button>
                  <button className='rite' onClick={handleDownload}>Imprimer le recu</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <div className="payment-gateway-modal-overlay">
        <div className="payment-gateway-modal-content">
          <div className='modal-header1'>
            <h5>Payement</h5>
          </div>
          <ToastContainer />
          <div className='ret'>
            <button
              className="payment-gateway-modal-close"
              onClick={onClose}
            >
              ← Retour
            </button>

            <div className='paycontent'>
              <h2 className='pinta'>Choisissez votre méthode de paiement</h2>
              <div className="payment-method-selection">
                <label className="payment-method-radio">
                  <input
                    type="radio"
                    name="payment-method"
                    value="mobile-money"
                    checked={paymentMethod === 'mobile-money'}
                    onChange={() => handlePaymentMethodSelect('mobile-money')}
                  />
                  <img src={monday} alt="monday" className="monday" />
                </label>
                <label className="payment-method-radio">
                  <input
                    type="radio"
                    name="payment-method"
                    value="cash"
                    checked={paymentMethod === 'cash'}
                    onChange={() => handlePaymentMethodSelect('cash')}
                  />
                  <img src={money} alt="money" className="money" />
                </label>
              </div>

              {paymentMethod === 'mobile-money' && (
                <div className="phone-input-container mobile-money-input">
                  <label>Enter your phone number</label>
                  <PhoneInput
                    country={'bj'}
                    value={phone}
                    onChange={(value) => setPhoneNumber(value)}
                    name="phone"
                    className="mx-auto"
                  />
                </div>
              )}

              {paymentMethod === 'cash' && (
                <div className="cash-payment-section">
                  <div className="cash-options">
                    <label>
                      <input
                        type="radio"
                        name="cash-option"
                        value="total"
                        checked={cashOption === 'total'}
                        onChange={() => setCashOption('total')}
                      />
                      Payer la totalité ({amountToPay} XOF)
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="cash-option"
                        value="partial"
                        checked={cashOption === 'partial'}
                        onChange={() => setCashOption('partial')}
                        disabled
                      />
                      Paiement partiel
                    </label>
                  </div>

                  <div className="cash-amount-input">
                    <label>Montant à payer</label>
                    <input
                      type="number"
                      min="0"
                      max={amountToPay}
                      value={cashAmount}
                      onChange={(e) => setCashAmount(e.target.value)}
                    />
                  </div>
                </div>
              )}


              <div className='aladji'>
                <button
                  onClick={handleMomoPaymentConfirmation}
                  disabled={paymentMethod === 'mobile-money' && !phone}
                  className="payment-confirm-button"
                >
                  Confirmer le Paiement
                </button>
                <p className='vonvon'>Your personal data will be used to process your order, support your <br></br> experience throughout this website, and for other purposes described <br></br>in our privacy policy.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentGatewayModal;